import * as React from "react";
import Svg, { Path, SvgProps } from "react-native-svg";
import { cssInterop } from "nativewind";

cssInterop(Svg, {
  className: {
    target: "style",
    nativeStyleToProp: { width: true, height: true },
  },
});

cssInterop(Path, {
  className: {
    // @ts-ignore
    target: "style",
    nativeStyleToProp: { stroke: true },
  },
});

type FileProps = SvgProps & {
  className?: string;
  pathClassName?: string;
};

function FileIcon({
  className,
  pathClassName = "stroke-black",
  ...props
}: FileProps) {
  return (
    <Svg
      width={16}
      height={16}
      viewBox="0 0 16 16"
      fill="none"
      className={className}
      {...props}
    >
      <Path
        d="M9.457 1.835v2.398c0 .325.13.637.36.867.231.23.544.359.87.359h2.75"
        className={pathClassName}
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M13.5 5.712v5.712a2.834 2.834 0 01-.908 1.98 2.854 2.854 0 01-2.048.76h-5.06a2.864 2.864 0 01-2.066-.75 2.843 2.843 0 01-.918-1.99V4.575a2.834 2.834 0 01.908-1.98 2.855 2.855 0 012.048-.76h3.809a2.336 2.336 0 011.574.603l1.973 1.815a1.981 1.981 0 01.688 1.459z"
        className={pathClassName}
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M5.572 9.121l1.253 1.253a.473.473 0 00.674 0l2.525-2.524"
        className={pathClassName}
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Svg>
  );
}

export default FileIcon;
